import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { apiBase, env } from './env';
import { ApiError, refreshSession, tokens } from './api';

/** Descarga un archivo autenticado (p. ej. comprobante PDF) y lo abre o comparte. */
export async function openAuthenticatedFile(path: string, filename: string): Promise<void> {
  const doFetch = () =>
    fetch(`${apiBase}${path}`, {
      headers: { Authorization: `Bearer ${tokens.access ?? ''}`, 'X-Tenant-Slug': env.tenantSlug, ...(env.isNative ? { 'X-Client': 'mobile' } : {}) },
      credentials: 'include',
    });
  let res = await doFetch();
  if (res.status === 401 && (await refreshSession())) res = await doFetch();
  if (!res.ok) throw new ApiError(res.status, 'DOWNLOAD_FAILED', 'No se pudo descargar el archivo');
  const blob = await res.blob();

  if (env.isNative) {
    const base64 = await new Promise<string>((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(String(r.result).split(',')[1] ?? '');
      r.onerror = reject;
      r.readAsDataURL(blob);
    });
    const saved = await Filesystem.writeFile({ path: filename, data: base64, directory: Directory.Cache });
    await Share.share({ title: filename, url: saved.uri, dialogTitle: 'Comprobante' });
    return;
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener';
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
